import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { RoleDetailsPage, ROLE_SCOPES } from "../../modules/role-management";
import TenantContextBanner from "../../components/common/TenantContextBanner";
import useAuth from "../../hooks/useAuth";

const RoleDetails = () => {
  const { isTenantUser, isSystemUser, activeTenantId } = useAuth();
  const location = useLocation();
  const isTenantScope =
    isTenantUser || location.pathname.startsWith("/tenant-");

  if (isSystemUser && isTenantScope && !activeTenantId) {
    return <Navigate to="/tenantmgmt" replace />;
  }

  return (
    <>
      {isTenantScope && !isTenantUser ? <TenantContextBanner /> : null}
      <RoleDetailsPage
        scope={isTenantScope ? ROLE_SCOPES.TENANT : ROLE_SCOPES.SYSTEM}
      />
    </>
  );
};

export default RoleDetails;
